//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.SelectDrawingViewList.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../Drawings/Drawings.SelectDrawingView.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BoundingBox",1,0],[1,"BoundingViews",0,"Drawings.SelectDrawingViewList",0],[0,"CreateSketches",1,1],[1,"Curves",0,"SelectNXObjectList",0],[0,"DestinationPart",1,0],[0,"DistanceFromViewPlane",1,0],[0,"ExtrudeSolidBody",1,1],[1,"Offset",0,"Expression",0],[0,"Output",1,0],[0,"ProcessSketchCurves",1,1],[0,"ProcessViewCurves",1,1],[0,"RepositionGeometry",1,0],[0,"Type",1,0],[1,"View",0,"Drawings.SelectDrawingView",1],[1,"Views",0,"Drawings.SelectDrawingViewList",0]],[[["offset","curves","sketches","option"],"Commit",{},4,1]],[]];
SPLM.Drawings.ViewCopyTo3dBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewCopyTo3dBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewCopyTo3dBuilder.Option = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

SPLM.Drawings.ViewCopyTo3dBuilder.DistanceFromViewPlaneOption = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

SPLM.Drawings.ViewCopyTo3dBuilder.Types = Object.freeze({
    "SelectedCurves" : "SelectedCurves", "SelectedViews" : "SelectedViews"});

SPLM.Drawings.ViewCopyTo3dBuilder.BoundingBoxOption = Object.freeze({
    "CurvesToCopy" : "CurvesToCopy", "EntireViews" : "EntireViews"});

SPLM.Drawings.ViewCopyTo3dBuilder.OutputOption = Object.freeze({
    "Sketches" : "Sketches", "SimpleCurves" : "SimpleCurves", "SketchesSolid" : "SketchesSolid", "PartsGroup" : "PartsGroup"});

export default SPLM;